import {
  Icon16Alert,
  Icon16AlertTriangle,
  Icon16Checkmark,
  Typography,
} from "@cur8/maneki";
import { ComponentType } from "react";
import { SpinningLoader } from "render/ui/presentation/SpinningLoader";
import styles from "./styles.module.sass";

export type StatusBadgeHighlight = "success" | "warning" | "error";

const STATUS_BADGE_ICONS: Record<StatusBadgeHighlight, ComponentType> = {
  success: Icon16Checkmark,
  warning: Icon16AlertTriangle,
  error: Icon16Alert,
};

export function StatusBadge({
  label,
  highlight,
  pending,
}: {
  label: string;
  highlight?: StatusBadgeHighlight;
  pending?: boolean;
}) {
  const Icon = highlight ? STATUS_BADGE_ICONS[highlight] : undefined;
  return (
    <div className={styles.statusBadge} data-highlight={highlight}>
      {pending ? (
        <span
          className={styles.badgeSpinner}
          data-testid="pill-spinner"
          aria-hidden="true"
        >
          <SpinningLoader success={false} />
        </span>
      ) : Icon ? (
        <Icon />
      ) : undefined}
      <Typography variant="eyebrow-m" as="span">
        {label}
      </Typography>
    </div>
  );
}
